(function () {
    'use strict';

    // Usage: <ib-passenger-tabs ></ib-passenger-tabs>
    // 
    // Creates: the form for the current passenger showing the fields depending on passengersData binding info.
    // If a form is specified in the containerForm binding, the component will treat the fields validation using ng-message
    // 

    angular.module('ib-passenger-tabs-module')
        .component('ibPassengerTabs', {
            controller: 'PassengerTabsController',
            controllerAs: 'pasTabsCtrl',
            bindings: {
                passengersInfo: '=',
                showData: '=',
                containerForm: '=',
                gdprInfo: '='
            },
            templateUrl: ['CheckinRouterConstants', function (CheckinRouterConstants) {
                return CheckinRouterConstants.templatesRoute + 'ib-passenger-tabs-view.html';
            }]
        });

})();